// Single source of truth for the supported locale set. `enabled` marks the
// locales that are LIVE on the storefront right now (routing, switcher,
// hreflang, sitemap read this). Non-enabled locales remain valid for API
// negotiation/fallback but are not yet surfaced to users. Phase 4 flips the
// remaining flags + backfills their catalog translations.
export const LOCALES = {
    en: { label: "English", dir: "ltr", base: true, enabled: true },
    tr: { label: "Türkçe", dir: "ltr", enabled: false },
    ar: { label: "العربية", dir: "rtl", enabled: true },
    ur: { label: "اردو", dir: "rtl", enabled: true },
    fa: { label: "فارسی", dir: "rtl", enabled: false },
    ckb: { label: "کوردی", dir: "rtl", enabled: false },
};
export const LOCALE_CODES = Object.keys(LOCALES);
export const DEFAULT_LOCALE = "en";
// Locales currently live on the storefront. Order is display order in the
// switcher (base locale first). Keep `en` first.
export const LIVE_LOCALE_CODES = LOCALE_CODES.filter((c) => LOCALES[c].enabled);
export function isLocale(value) {
    return (typeof value === "string" &&
        Object.prototype.hasOwnProperty.call(LOCALES, value));
}
export function isLiveLocale(value) {
    return isLocale(value) && LOCALES[value].enabled;
}
export function dirOf(locale) {
    return LOCALES[locale].dir;
}
// Native-name label for the switcher (English / العربية / اردو …).
export function localeName(locale) {
    return LOCALES[locale].label;
}
